<ng-template appSpotlightHeaderInflatorContainer></ng-template>
